import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { environment } from '@env';
import { ErrorHandlerService } from './response-utils.service';
import { Customer } from '@components/customer';
import { catchError } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CustomerService {
  private http = inject(HttpClient);
  private errorHandler = inject(ErrorHandlerService);

  private URL: string = environment.apiUrl + '/tenant';

  getTenantList(): Observable<Customer[]> {
    const url = this.URL + '/getAllTenant';
    return this.http.get<Customer[]>(url).pipe(
      catchError((error: HttpErrorResponse) => {
        this.errorHandler.errorHandler(error);
        return throwError(() => error);
      }),
    );
  }

  createTenant(customer: Customer) {
    return this.http
      .post(this.URL + '/create', customer)
      .pipe(catchError((error: HttpErrorResponse) => this.errorHandler.errorHandler(error)));
  }

  updateTenant(customer: Customer) {
    return this.http
      .put(this.URL + '/update', customer)
      .pipe(catchError((error: HttpErrorResponse) => this.errorHandler.errorHandler(error)));
  }

  getTenantById(id: number) {
    const url = `${this.URL}/get-by-id/${id}`;
    return this.http
      .get(url)
      .pipe(catchError((error: HttpErrorResponse) => this.errorHandler.errorHandler(error)));
  }

  checkCustomerName(name: string) {
    const urlSort = this.URL + '/getByName';
    return this.http
      .get(urlSort + '?name=' + name)
      .pipe(catchError((error: HttpErrorResponse) => this.errorHandler.errorHandler(error)));
  }

  checkTenantKey(tenantKey: string) {
    const urlSort = this.URL + '/getByTenantKey';
    return this.http
      .get(urlSort + '?tenantKey=' + tenantKey)
      .pipe(catchError((error: HttpErrorResponse) => this.errorHandler.errorHandler(error)));
  }

  checkTenantEmail(name: string) {
    const urlSort = this.URL + '/get-by-email';
    return this.http
      .get(urlSort + '?email=' + name)
      .pipe(catchError((error: HttpErrorResponse) => this.errorHandler.errorHandler(error)));
  }

  getTimeZones() {
    return this.http
      .get(this.URL + '/getAllTimezone')
      .pipe(catchError((error: HttpErrorResponse) => this.errorHandler.errorHandler(error)));
  }

  getAllStacks() {
    const url = this.URL + '/stacks/getAllStacks';
    return this.http
      .get(url)
      .pipe(catchError((error: HttpErrorResponse) => this.errorHandler.errorHandler(error)));
  }

  getTenantNames() {
    return this.http
      .get(this.URL + '/list/name-and-key')
      .pipe(catchError((error: HttpErrorResponse) => this.errorHandler.errorHandler(error)));
  }

  getOperationalApiEnabledCustomers(type: string) {
    const params = new HttpParams().set('integration-type', type);
    return this.http
      .get(this.URL + '/integration-customers', { params })
      .pipe(catchError((error: HttpErrorResponse) => this.errorHandler.errorHandler(error)));
  }

  getCustomerStatusTypes() {
    const url = this.URL + '/tenant-status';
    return this.http
      .get(url)
      .pipe(catchError((error: HttpErrorResponse) => this.errorHandler.errorHandler(error)));
  }
}
